<div class="icon-container">
  <ng-container>
    <div class="icon-item" (click)="showReport()">
      <i class="pi pi-print icon"></i>
      <span class="icon-label">Receipt Order</span>
    </div>
    <div class="icon-item" (click)="showReport1()">
      <i class="pi pi-print icon"></i>
      <span class="icon-label">GRN</span>
    </div>
  </ng-container>
</div>
